import { reducer as formReducer } from 'redux-form'

import surveyReducer from 'modules/survey/reducer';

export default {
  form: formReducer,
  survey: surveyReducer
}